// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TopPartnersContainerSkeleton_wrapper__DLLVr","shape":"TopPartnersContainerSkeleton_shape__s4lxs"};